import { createFileRoute } from '@tanstack/react-router'

import MembersLayout from './-components/members-layout'

export const Route = createFileRoute('/_authenticated/$alias/settings/members/')({
  component: MembersLayout,
})
